import { createAction } from 'redux-actions';
export const setActiveRecommendedSeats = createAction('SET_ACTIVE_RECOMMENDED_SEATS');
export const toggleActiveRecommendedSeats = createAction('TOGGLE_ACTIVE_RECOMMENDED_SEATS');
